/*
 * learn-watch.js — the Watch page (sections/learn-watch2.liquid).
 *
 * One player, a TikTok-style side panel, a playlist row, a grid view and
 * cinema mode. Nothing third-party loads until the first player mounts
 * (YouTube IFrame API on demand, TikTok player v1 iframe, Instagram on tap).
 *
 *   likes / saves   → localStorage learn:likes / learn:saves (shared with learn.js)
 *                     + optional POST <api>/like | /save when data-api is set
 *   sound / cinema  → localStorage learn:watch:sound / learn:watch:cinema
 *   URL             → ?v=<handle> via history.replaceState on every swap
 *   keys            → N next · P previous · L like · C cinema · Esc · Space (stage)
 *
 * TikTok player v1 speaks postMessage: {"x-tiktok-player":true,type,value}.
 * onStateChange value 0 = ended, 1 playing, 2 paused, 3 buffering. Commands
 * play / pause / mute / unMute / seek. When no end event arrives we fall back
 * to onCurrentTime reaching duration, then to watch_seconds + 2 s.
 */
(function () {
  "use strict";
  var root = document.querySelector("[data-watch]");
  if (!root) return;

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return [].slice.call((el || root).querySelectorAll(sel)); };
  var LS = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } }
  };

  /* ---------- data ---------- */
  var items = [];
  try { items = JSON.parse($("[data-watch-data]").textContent) || []; } catch (e) { items = []; }
  if (!items.length) return;
  var byHandle = {};
  items.forEach(function (it, i) {
    it.index = i;
    it.tags = it.tags || [];
    it.family = famOf(it.platform);
    it.vertical = it.platform === "tiktok" || it.platform === "youtube_short" || it.platform === "instagram_reel";
    it.tutorial = isTutorial(it);
    it.hashtags = hashtagsOf(it);
    byHandle[it.handle] = it;
  });

  function famOf(p) { p = p || ""; if (p.indexOf("youtube") === 0) return "youtube"; if (p.indexOf("instagram") === 0) return "instagram"; return p; }
  function isTutorial(it) {
    if (it.ctype === "tutorial") return true;
    if (it.tags.some(function (t) { return /tutorial/i.test(t); })) return true;
    return /\btutorial|\btip\s*\d|^tip\b|\bhow to\b/i.test(it.title || "");
  }
  function hashtagsOf(it) {
    var seen = {}, out = [];
    function add(t, from) { t = String(t || "").replace(/^#/, "").trim(); if (!t) return; var k = t.toLowerCase(); if (seen[k]) return; seen[k] = 1; out.push({ tag: t, from: from }); }
    it.tags.forEach(function (t) { add(t, "tag"); });
    if (it.topic && it.topic.name) add(it.topic.name, "topic");
    ((it.title || "") + " " + (it.caption || "")).replace(/#([\p{L}\p{N}_]+)/gu, function (m, t) { add(t, "hash"); return m; });
    return out;
  }
  function cleanTitle(t) { return String(t || "").replace(/#[\p{L}\p{N}_]+/gu, "").replace(/\s{2,}/g, " ").trim(); }
  function fmtN(n) { n = Number(n) || 0; if (n >= 1e6) return (n / 1e6).toFixed(n >= 1e7 ? 0 : 1).replace(/\.0$/, "") + "M"; if (n >= 1e3) return (n / 1e3).toFixed(n >= 1e4 ? 0 : 1).replace(/\.0$/, "") + "K"; return String(n); }
  function fmtT(s) { s = Math.round(Number(s) || 0); return Math.floor(s / 60) + ":" + ("0" + (s % 60)).slice(-2); }
  function platformLabel(p) { return { youtube: "YouTube", youtube_short: "YouTube", tiktok: "TikTok", instagram_reel: "Instagram", instagram_post: "Instagram" }[p] || (p || "Video"); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  /* ---------- config + refs ---------- */
  var cfg = {
    autoplay: root.getAttribute("data-autoplay") === "true",
    nextSecs: parseInt(root.getAttribute("data-next-seconds"), 10) || 5,
    filter: root.getAttribute("data-default-filter") || "all",
    tab: root.getAttribute("data-default-tab") || "auto",
    api: (root.getAttribute("data-api") || "").replace(/\/$/, ""),
    shareBase: root.getAttribute("data-share-base") || (location.origin + location.pathname)
  };
  var el = {
    stage: $("[data-stage]"), player: $("[data-player]"), box: $("[data-player-box]"), mount: $("[data-mount]"), poster: $("[data-poster]"),
    playBig: $("[data-play-big]"), unmute: $("[data-unmute]"),
    nextOverlay: $("[data-next-overlay]"), nextCount: $("[data-next-count]"), nextThumb: $("[data-next-thumb]"), nextTitle: $("[data-next-title]"), nextMeta: $("[data-next-meta]"),
    endOverlay: $("[data-end-overlay]"),
    prev: $("[data-prev]"), next: $("[data-next]"), cinema: $("[data-cinema]"), backdrop: $("[data-cinema-backdrop]"),
    date: $("[data-date]"), badge: $("[data-platform-badge]"), duration: $("[data-duration]"), watchOn: $("[data-watch-on]"), watchOnLabel: $("[data-watch-on-label]"),
    title: $("[data-title]"), captionWrap: $("[data-caption-wrap]"), caption: $("[data-caption]"), captionMore: $("[data-caption-more]"), tags: $("[data-tags]"),
    likes: $$("[data-like]"), likeCounts: $$("[data-like-count]"), saves: $$("[data-save]"), saveCounts: $$("[data-save-count]"), commentCounts: $$("[data-comment-count]"), queueCount: $("[data-queue-count]"),
    glyph: $("[data-platform-glyph]"), share: $(".lw-share"), linkrow: $(".lw-linkrow"), commentsPane: $('[data-tab-pane="comments"]'), sheets: $$("[data-sheet]"), sheetBackdrop: $("[data-sheet-backdrop]"),
    copyUrl: $("[data-copy-url]"), copyBtn: $("[data-copy-link]"),
    commentsHost: $("[data-comments-host]"), formHost: $("[data-comment-form-host]"), panelScroll: $("[data-panel-scroll]"),
    queue: $("[data-queue]"), queueEmpty: $("[data-queue-empty]"), filters: $("[data-filters]"), playlists: $("[data-playlists]"), grid: $("[data-grid]"),
    viewPlayer: $('[data-view="player"]'), viewGrid: $('[data-view="grid"]')
  };
  var baseTitle = document.title;
  var mqMobile = window.matchMedia("(max-width: 900px)");
  var isMobile = function () { return mqMobile.matches; };
  var GLYPH = {
    tiktok: '<svg viewBox="0 0 24 24"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>',
    youtube: '<svg viewBox="0 0 24 24"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8ZM9.6 15.6V8.4l6.2 3.6-6.2 3.6Z"/></svg>',
    instagram: '<svg viewBox="0 0 24 24"><path d="M12 2.2c3.2 0 3.6 0 4.8.1 3.2.1 4.8 1.7 4.9 4.9.1 1.3.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 3.2-1.7 4.8-4.9 4.9-1.3.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-3.3-.1-4.8-1.7-4.9-4.9C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8C2.4 3.9 4 2.4 7.2 2.3c1.3-.1 1.6-.1 4.8-.1ZM12 0C8.7 0 8.3 0 7.1.1 2.7.3.3 2.7.1 7.1 0 8.3 0 8.7 0 12s0 3.7.1 4.9c.2 4.4 2.6 6.8 7 7 1.2.1 1.6.1 4.9.1s3.7 0 4.9-.1c4.4-.2 6.8-2.6 7-7 .1-1.2.1-1.6.1-4.9s0-3.7-.1-4.9c-.2-4.4-2.6-6.8-7-7C15.7 0 15.3 0 12 0Zm0 5.8a6.2 6.2 0 1 0 0 12.4 6.2 6.2 0 0 0 0-12.4ZM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm6.4-11.8a1.4 1.4 0 1 0 0 2.9 1.4 1.4 0 0 0 0-2.9Z"/></svg>'
  };
  var state = { cur: null, order: [], playlist: "all", filter: cfg.filter, sound: !!LS.get("learn:watch:sound", false), kind: null, yt: null, tt: null, ttEnded: false, ttTimer: null, countdown: null, playing: false, muted: true, view: "player" };

  /* ---------- toast ---------- */
  var toastEl = document.createElement("div"); toastEl.className = "lw-toast"; toastEl.setAttribute("role", "status"); document.body.appendChild(toastEl);
  var toastT;
  function toast(msg) { toastEl.textContent = msg; toastEl.classList.add("is-on"); clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove("is-on"); }, 1800); }
  function copyText(t) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(t).catch(function () { return legacyCopy(t); });
    return Promise.resolve(legacyCopy(t));
  }
  function legacyCopy(t) { var ta = document.createElement("textarea"); ta.value = t; ta.setAttribute("readonly", ""); ta.style.position = "fixed"; ta.style.opacity = "0"; document.body.appendChild(ta); ta.select(); try { document.execCommand("copy"); } catch (e) { /* no-op */ } document.body.removeChild(ta); }

  /* ---------- ordering: playlist ∩ filter ---------- */
  function playlistTest(btn) {
    var match = btn.getAttribute("data-match"), val = (btn.getAttribute("data-value") || "").toLowerCase();
    return function (it) {
      switch (match) {
        case "tutorial": return it.tutorial;
        case "tag": return it.tags.some(function (t) { return t.toLowerCase() === val || t.toLowerCase().replace(/\s+/g, "-") === val; });
        case "topic": return !!(it.topic && (it.topic.handle || "").toLowerCase() === val);
        case "keyword": return val && ((it.title || "") + " " + (it.caption || "") + " " + it.tags.join(" ")).toLowerCase().indexOf(val) > -1;
        case "platform": return val && (it.family === val || it.platform === val);
        default: return true;
      }
    };
  }
  var playlistFns = { all: function () { return true; } };
  $$("[data-playlist]").forEach(function (btn) {
    var id = btn.getAttribute("data-playlist");
    if (id !== "all") playlistFns[id] = playlistTest(btn);
    var matches = items.filter(playlistFns[id]);
    var n = matches.length;
    var c = $("[data-count]", btn); if (c) c.textContent = n;
    var cover = $("[data-pl-cover]", btn);
    var withImg = matches.filter(function (it) { return it.thumb; })[0];
    if (cover && withImg) cover.src = withImg.thumb;
    btn.hidden = n === 0;
    btn.addEventListener("click", function () { setPlaylist(id); });
  });
  function filterTest(it) {
    switch (state.filter) {
      case "tiktok": case "youtube": case "instagram": return it.family === state.filter;
      case "tutorial": return it.tutorial;
      default: return true;
    }
  }
  // hide filter chips with nothing behind them
  $$("[data-filter]").forEach(function (chip) {
    var f = chip.getAttribute("data-filter");
    var n = f === "all" ? items.length : items.filter(function (it) { return f === "tutorial" ? it.tutorial : it.family === f; }).length;
    chip.hidden = n === 0;
    if (n > 0 && f !== "all") chip.innerHTML = esc(chip.textContent.trim()) + ' <span class="lw-tab__n">' + n + "</span>";
    chip.addEventListener("click", function () { setFilter(f); });
  });
  if (state.filter !== "all" && !items.some(filterTest)) state.filter = "all";

  function recompute() {
    var fn = playlistFns[state.playlist] || playlistFns.all;
    state.order = items.filter(function (it) { return fn(it) && filterTest(it); }).map(function (it) { return it.handle; });
    var inOrder = {}; state.order.forEach(function (h) { inOrder[h] = 1; });
    $$("[data-watch-tile]").forEach(function (t) { t.hidden = !inOrder[t.getAttribute("data-watch-tile")]; });
    if (el.queueEmpty) el.queueEmpty.hidden = state.order.length > 0;
    if (el.queueCount) el.queueCount.textContent = state.order.length;
    $$("[data-playlist]").forEach(function (b) { var on = b.getAttribute("data-playlist") === state.playlist; b.classList.toggle("is-on", on); b.setAttribute("aria-pressed", on ? "true" : "false"); });
    $$("[data-filter]").forEach(function (b) { var on = b.getAttribute("data-filter") === state.filter; b.classList.toggle("is-on", on); b.setAttribute("aria-pressed", on ? "true" : "false"); });
    updateArrows();
  }
  function setPlaylist(id) { state.playlist = id; recompute(); if (state.view === "player" && state.order.length && state.order.indexOf(state.cur) === -1) select(state.order[0], { autoplay: true }); }
  function setFilter(f) { state.filter = f; recompute(); }
  function curIdx() { return state.order.indexOf(state.cur); }
  function neighbour(d) { var i = curIdx(); if (i === -1) return state.order[0] || null; var j = i + d; return j >= 0 && j < state.order.length ? state.order[j] : null; }
  function updateArrows() { if (el.prev) el.prev.disabled = !neighbour(-1); if (el.next) el.next.disabled = !neighbour(1); }

  /* ---------- panel ---------- */
  function renderPanel(it) {
    var liked = LS.get("learn:likes", []).indexOf(it.handle) > -1, saved = LS.get("learn:saves", []).indexOf(it.handle) > -1;
    if (el.title) el.title.textContent = cleanTitle(it.title) || it.title;
    if (el.caption) { el.caption.textContent = it.caption || ""; el.captionWrap.classList.add("is-clamped"); el.captionMore.hidden = true; el.captionMore.setAttribute("aria-expanded", "false"); el.captionMore.textContent = "more"; requestAnimationFrame(function () { el.captionMore.hidden = !(el.caption.scrollHeight > el.caption.clientHeight + 2); }); }
    if (el.tags) el.tags.innerHTML = it.hashtags.map(function (h) { return '<a class="lw-tag" href="/search?view=learn&type=article&q=' + encodeURIComponent(h.tag) + '"><b>#</b>' + esc(h.tag.replace(/\s+/g, "")) + "</a>"; }).join("");
    if (el.date) { el.date.textContent = it.date || ""; el.date.setAttribute("datetime", it.dateISO || ""); }
    if (el.badge) { el.badge.textContent = platformLabel(it.platform); el.badge.className = "lw-badge lw-badge--" + it.family; }
    if (el.glyph) { el.glyph.innerHTML = GLYPH[it.family] || ""; el.glyph.setAttribute("title", platformLabel(it.platform)); }
    if (el.duration) { el.duration.hidden = !(it.secs > 0); el.duration.textContent = it.secs > 0 ? fmtT(it.secs) : ""; }
    if (el.watchOn) { el.watchOn.href = it.vurl || it.url; el.watchOnLabel.textContent = it.vurl ? "Watch on " + platformLabel(it.platform) : "Open post"; }
    el.likes.forEach(function (b) { setPressed(b, liked); }); el.saves.forEach(function (b) { setPressed(b, saved); });
    el.likeCounts.forEach(function (c) { c.textContent = fmtN((it.likes || 0) + (liked ? 1 : 0)); });
    el.saveCounts.forEach(function (c) { c.textContent = fmtN((it.saves || 0) + (saved ? 1 : 0)); });
    el.commentCounts.forEach(function (c) { c.textContent = it.comments || 0; });
    if (el.copyUrl) el.copyUrl.value = shareUrl(it);
    var ct = document.querySelector('template[data-watch-comments="' + it.handle + '"]'), cf = document.querySelector('template[data-watch-cform="' + it.handle + '"]');
    if (el.commentsHost) { el.commentsHost.innerHTML = ""; if (ct) el.commentsHost.appendChild(ct.content.cloneNode(true)); }
    if (el.formHost) { el.formHost.innerHTML = ""; if (cf) { el.formHost.appendChild(cf.content.cloneNode(true)); wireForm(); } }
    $$("[data-watch-tile]").forEach(function (t) { var on = t.getAttribute("data-watch-tile") === it.handle; t.classList.toggle("is-current", on); var a = $("[data-tile-link]", t); if (a) { if (on) a.setAttribute("aria-current", "true"); else a.removeAttribute("aria-current"); } });
  }
  function setPressed(btn, on) { if (btn) btn.setAttribute("aria-pressed", on ? "true" : "false"); }
  function shareUrl(it) { return cfg.shareBase + "?v=" + encodeURIComponent(it.handle); }
  function wireForm() {
    var f = $(".lw-cform", el.formHost); if (!f) return;
    f.classList.add("is-collapsed");
    var ta = $("textarea", f);
    function grow() { ta.style.height = "auto"; ta.style.height = Math.min(140, ta.scrollHeight) + "px"; }
    ta.addEventListener("focus", function () { f.classList.remove("is-collapsed"); });
    ta.addEventListener("input", grow);
  }
  if (el.captionMore) el.captionMore.addEventListener("click", function () { var open = el.captionWrap.classList.toggle("is-clamped") === false; el.captionMore.setAttribute("aria-expanded", open ? "true" : "false"); el.captionMore.textContent = open ? "less" : "more"; });

  /* ---------- tabs ---------- */
  function setTab(name, opts) {
    $$("[data-tab-btn]").forEach(function (b) { var on = b.getAttribute("data-tab-btn") === name; b.setAttribute("aria-selected", on ? "true" : "false"); b.tabIndex = on ? 0 : -1; });
    $$("[data-tab-pane]").forEach(function (p) { p.hidden = !isMobile() && p.getAttribute("data-tab-pane") !== name; });   // mobile: both panes live (videos inline, comments in the sheet)
    if (el.formHost) el.formHost.hidden = !isMobile() && name !== "comments";   // desktop: the Add-comment box only belongs to the Comments tab
    if (opts && opts.scroll && el.panelScroll) { var pane = $('[data-tab-pane="' + name + '"]'); if (pane) { var top = pane.offsetTop - 60; if (window.innerWidth <= 900) { window.scrollTo({ top: pane.getBoundingClientRect().top + window.pageYOffset - 80, behavior: "smooth" }); } else { el.panelScroll.scrollTo({ top: top, behavior: "smooth" }); } } }
  }
  $$("[data-tab-btn]").forEach(function (b) { b.addEventListener("click", function () { setTab(b.getAttribute("data-tab-btn")); }); });
  var jump = $("[data-comments-jump]"); if (jump) jump.addEventListener("click", function () { if (isMobile()) { openSheet("comments"); return; } setTab("comments", { scroll: true }); var ta = $("textarea", el.formHost); if (ta) ta.focus({ preventScroll: true }); });

  /* ---------- player ---------- */
  function clearPlayer() {
    stopCountdown();
    if (state.yt && state.yt.destroy) { try { state.yt.destroy(); } catch (e) { /* already gone */ } }
    state.yt = null; state.tt = null; state.kind = null; state.playing = false; state.ttEnded = false;
    clearTimeout(state.ttTimer); state.ttTimer = null;
    el.mount.innerHTML = "";
    el.player.classList.remove("is-mounted");
    hideUnmute(); el.endOverlay.hidden = true;
  }
  function setPoster(it) {
    if (!el.poster) return;
    if (it.image) { el.poster.src = it.image; el.poster.hidden = false; } else { el.poster.removeAttribute("src"); el.poster.hidden = true; }
    el.player.classList.toggle("is-vertical", !!it.vertical);
    el.player.classList.toggle("is-landscape", !it.vertical);
  }
  function mount(it, autoplay) {
    clearPlayer();
    var can = it.embeddable !== false && it.id;
    state.muted = !state.sound;
    if (!can) { el.playBig.onclick = function () { if (it.vurl) window.open(it.vurl, "_blank", "noopener"); }; return; }
    el.playBig.onclick = function () { mount(it, true); };
    if (!autoplay) return;  // facade until the user presses play
    el.player.classList.add("is-mounted");
    if (it.family === "youtube") mountYouTube(it);
    else if (it.platform === "tiktok") mountTikTok(it);
    else mountInstagram(it);
    document.dispatchEvent(new CustomEvent("learn:video-play", { detail: { platform: it.platform, id: it.id } }));
  }
  var unmuteT = null;
  function hideUnmute() { el.unmute.hidden = true; el.player.classList.remove("has-unmute"); clearTimeout(unmuteT); }
  function showUnmute() { if (!state.muted) { hideUnmute(); return; } el.unmute.hidden = false; el.player.classList.add("has-unmute"); clearTimeout(unmuteT); unmuteT = setTimeout(hideUnmute, 10000); }
  el.unmute.addEventListener("click", function () { unmute(); });
  function unmute() {
    state.sound = true; LS.set("learn:watch:sound", true); state.muted = false; hideUnmute();
    if (state.kind === "yt" && state.yt) { try { state.yt.unMute(); state.yt.setVolume(100); } catch (e) { /* not ready */ } }
    if (state.kind === "tt") ttSend("unMute");
  }

  // --- YouTube (IFrame API, nocookie host, loaded once on first use)
  var ytReady = null;
  function loadYT() {
    if (window.YT && window.YT.Player) return Promise.resolve();
    if (ytReady) return ytReady;
    ytReady = new Promise(function (resolve) {
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () { if (prev) { try { prev(); } catch (e) { /* other script */ } } resolve(); };
      var s = document.createElement("script"); s.src = "https://www.youtube.com/iframe_api"; s.async = true; document.head.appendChild(s);
    });
    return ytReady;
  }
  function mountYouTube(it) {
    var host = document.createElement("div"); el.mount.appendChild(host);
    var token = it.handle;
    loadYT().then(function () {
      if (state.cur !== token || !el.player.classList.contains("is-mounted")) return;
      state.kind = "yt";
      state.yt = new YT.Player(host, {
        videoId: it.id, host: "https://www.youtube-nocookie.com",
        playerVars: { autoplay: 1, mute: state.sound ? 0 : 1, playsinline: 1, rel: 0, modestbranding: 1, enablejsapi: 1, origin: location.origin },
        events: {
          onReady: function (e) { if (state.sound) { try { e.target.unMute(); } catch (x) { /* ignore */ } } try { e.target.playVideo(); } catch (x) { /* ignore */ } showUnmute(); var d = e.target.getDuration && e.target.getDuration(); if (d > 0 && el.duration) { el.duration.hidden = false; el.duration.textContent = fmtT(d); } },
          onStateChange: function (e) { state.playing = e.data === 1; if (e.data === 1 && state.yt && state.yt.isMuted && !state.yt.isMuted()) { state.muted = false; hideUnmute(); } if (e.data === 0) onEnded(); }
        }
      });
    });
  }

  // --- TikTok player v1
  function ttSend(type, value) { if (!state.tt || !state.tt.contentWindow) return; var msg = { "x-tiktok-player": true, type: type }; if (value !== undefined) msg.value = value; try { state.tt.contentWindow.postMessage(msg, "https://www.tiktok.com"); } catch (e) { /* ignore */ } }
  function mountTikTok(it) {
    var f = document.createElement("iframe");
    f.src = "https://www.tiktok.com/player/v1/" + encodeURIComponent(it.id) + "?autoplay=1&muted=" + (state.sound ? 0 : 1) + "&loop=0&description=0&music_info=0&rel=0&controls=1&progress_bar=1&play_button=1&volume_control=1&fullscreen_button=1&timestamp=1";
    f.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen");
    f.setAttribute("allowfullscreen", ""); f.setAttribute("title", it.title || "TikTok video"); f.setAttribute("loading", "eager");
    el.mount.appendChild(f);
    state.kind = "tt"; state.tt = f;
    showUnmute();
    // fallback when the player never reports an end
    if (it.secs > 0) state.ttTimer = setTimeout(function () { if (state.kind === "tt" && !state.ttEnded) onEnded(); }, (it.secs + 2) * 1000);
  }
  window.addEventListener("message", function (e) {
    if (!state.tt || state.kind !== "tt") return;
    if (typeof e.origin !== "string" || e.origin.indexOf("tiktok.com") === -1) return;
    var d = e.data; if (!d || typeof d !== "object" || !d["x-tiktok-player"]) return;
    var it = byHandle[state.cur];
    if (d.type === "onPlayerReady") { if (state.sound) ttSend("unMute"); ttSend("play"); }
    if (d.type === "onStateChange") { var v = Number(d.value); state.playing = v === 1; if (v === 0 && !state.ttEnded) { state.ttEnded = true; onEnded(); } }
    if (d.type === "onMute") { state.muted = !!(d.value && (d.value.muted !== undefined ? d.value.muted : d.value)); if (!state.muted) hideUnmute(); }
    if (d.type === "onCurrentTime" && d.value) {
      var cur = Number(d.value.currentTime), dur = Number(d.value.duration);
      if (dur > 0 && it && el.duration && el.duration.hidden) { el.duration.hidden = false; el.duration.textContent = fmtT(dur); }
      if (dur > 0 && cur >= dur - 0.35 && !state.ttEnded) { state.ttEnded = true; onEnded(); }
    }
  });

  // --- Instagram: embed on tap only (no autoplay, no end event)
  function mountInstagram(it) {
    var f = document.createElement("iframe");
    f.src = "https://www.instagram.com/" + (it.platform === "instagram_post" ? "p" : "reel") + "/" + encodeURIComponent(it.id) + "/embed";
    f.setAttribute("allow", "autoplay; clipboard-write; encrypted-media; picture-in-picture"); f.setAttribute("allowfullscreen", ""); f.setAttribute("title", it.title || "Instagram video"); f.setAttribute("loading", "eager");
    el.mount.appendChild(f); state.kind = "ig";
    if (it.secs > 0) state.ttTimer = setTimeout(function () { if (state.kind === "ig") onEnded(); }, (it.secs + 2) * 1000);
  }

  function togglePlay() {
    if (!el.player.classList.contains("is-mounted")) { var it = byHandle[state.cur]; if (it) mount(it, true); return; }
    if (state.kind === "yt" && state.yt) { try { if (state.yt.getPlayerState() === 1) state.yt.pauseVideo(); else state.yt.playVideo(); } catch (e) { /* ignore */ } }
    else if (state.kind === "tt") ttSend(state.playing ? "pause" : "play");
  }

  /* ---------- auto-next ---------- */
  function onEnded() {
    if (document.hidden) { state.playing = false; }
    var nh = neighbour(1);
    if (!nh) { el.endOverlay.hidden = false; return; }
    startCountdown(nh);
  }
  function startCountdown(nh) {
    stopCountdown();
    var n = byHandle[nh]; if (!n) return;
    el.nextThumb.src = n.thumb || n.image || ""; el.nextThumb.hidden = !(n.thumb || n.image);
    el.nextTitle.textContent = cleanTitle(n.title) || n.title; el.nextMeta.textContent = platformLabel(n.platform) + " · " + (n.date || "");
    var left = cfg.nextSecs; el.nextCount.textContent = left; el.nextOverlay.hidden = false;
    state.countdown = setInterval(function () { left -= 1; el.nextCount.textContent = Math.max(0, left); if (left <= 0) { stopCountdown(); select(nh, { autoplay: true }); } }, 1000);
  }
  function stopCountdown() { clearInterval(state.countdown); state.countdown = null; if (el.nextOverlay) el.nextOverlay.hidden = true; }
  $("[data-next-cancel]").addEventListener("click", function () { stopCountdown(); });
  $("[data-next-now]").addEventListener("click", function () { var nh = neighbour(1); stopCountdown(); if (nh) select(nh, { autoplay: true }); });
  $("[data-end-replay]").addEventListener("click", function () { var it = byHandle[state.cur]; el.endOverlay.hidden = true; if (it) mount(it, true); });
  $("[data-end-all]").addEventListener("click", function () { el.endOverlay.hidden = true; state.playlist = "all"; state.filter = "all"; recompute(); if (state.order[0]) select(state.order[0], { autoplay: true }); });

  /* ---------- selection ---------- */
  function select(handle, opts) {
    opts = opts || {};
    var it = byHandle[handle]; if (!it) return;
    var changed = state.cur !== handle;
    state.cur = handle;
    setPoster(it); renderPanel(it); updateArrows();
    var auto = opts.autoplay !== undefined ? opts.autoplay : cfg.autoplay;
    if (it.family === "instagram" && !opts.user) auto = false;   // IG embeds don't autoplay — keep the facade
    mount(it, auto);
    try { var u = new URL(location.href); u.searchParams.set("v", handle); history.replaceState(null, "", u.pathname + u.search + (location.hash || "")); } catch (e) { /* ignore */ }
    document.title = (cleanTitle(it.title) || it.title) + " · " + baseTitle.replace(/^.*?·\s*/, "");
    if (changed && opts.user) {
      var tile = el.queue && $('[data-watch-tile="' + handle + '"]', el.queue);
      if (tile && tile.scrollIntoView && !tile.hidden) tile.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
    }
    document.dispatchEvent(new CustomEvent("learn:watch-select", { detail: { handle: handle } }));
  }
  function go(d, user) { var h = neighbour(d); if (h) select(h, { autoplay: true, user: user }); }
  el.prev.addEventListener("click", function () { go(-1, true); });
  el.next.addEventListener("click", function () { go(1, true); });

  // tiles (queue + grid) — swap in place, keep the href for new-tab/middle-click
  root.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("[data-tile-link]");
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    var h = a.getAttribute("data-tile-link");
    if (state.view === "grid") setView("player");
    select(h, { autoplay: true, user: true });
    if (window.innerWidth <= 900 || state.view === "grid") el.stage.scrollIntoView({ block: "start", behavior: "smooth" });
  });

  /* ---------- like / save ---------- */
  function toggleStore(key, handle) { var cur = LS.get(key, []); var i = cur.indexOf(handle); if (i > -1) cur.splice(i, 1); else cur.unshift(handle); LS.set(key, cur); return i === -1; }
  function postApi(action, handle, on) {
    if (!cfg.api || !window.fetch) return;
    fetch(cfg.api + "/" + action, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ handle: handle, on: on }) }).catch(function () { /* offline / not deployed yet */ });
  }
  function pop(btn) { btn.classList.remove("is-pop"); void btn.offsetWidth; btn.classList.add("is-pop"); }
  function toggleLike() { var it = byHandle[state.cur]; if (!it) return; var on = toggleStore("learn:likes", it.handle); el.likes.forEach(function (b) { setPressed(b, on); pop(b); }); el.likeCounts.forEach(function (c) { c.textContent = fmtN((it.likes || 0) + (on ? 1 : 0)); }); postApi("like", it.handle, on); }
  function toggleSave() { var it = byHandle[state.cur]; if (!it) return; var on = toggleStore("learn:saves", it.handle); el.saves.forEach(function (b) { setPressed(b, on); pop(b); }); el.saveCounts.forEach(function (c) { c.textContent = fmtN((it.saves || 0) + (on ? 1 : 0)); }); postApi("save", it.handle, on); toast(on ? "Saved to My learning" : "Removed from saved"); }
  el.likes.forEach(function (b) { b.addEventListener("click", toggleLike); });
  el.saves.forEach(function (b) { b.addEventListener("click", toggleSave); });

  /* ---------- share / copy / embed ---------- */
  function embedCode(it) {
    if (it.family === "youtube") return '<iframe width="560" height="' + (it.vertical ? 996 : 315) + '" src="https://www.youtube-nocookie.com/embed/' + it.id + '" title="' + esc(it.title) + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    if (it.platform === "tiktok") return '<blockquote class="tiktok-embed" cite="' + esc(it.vurl || "") + '" data-video-id="' + it.id + '" style="max-width:605px;min-width:325px"><section></section></blockquote><script async src="https://www.tiktok.com/embed.js"></' + 'script>';
    if (it.family === "instagram") return '<blockquote class="instagram-media" data-instgrm-permalink="' + esc(it.vurl || "") + '" data-instgrm-version="14"></blockquote><script async src="https://www.instagram.com/embed.js"></' + 'script>';
    return shareUrl(it);
  }
  $$("[data-share]").forEach(function (b) {
    b.addEventListener("click", function () {
      var it = byHandle[state.cur]; if (!it) return;
      var url = shareUrl(it), text = cleanTitle(it.title) || it.title, kind = b.getAttribute("data-share"), href = null;
      switch (kind) {
        case "whatsapp": href = "https://wa.me/?text=" + encodeURIComponent(text + " " + url); break;
        case "facebook": href = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url); break;
        case "x": href = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(text) + "&url=" + encodeURIComponent(url); break;
        case "pinterest": href = "https://pinterest.com/pin/create/button/?url=" + encodeURIComponent(url) + "&description=" + encodeURIComponent(text) + (it.image ? "&media=" + encodeURIComponent(it.image) : ""); break;
        case "embed": copyText(embedCode(it)).then(function () { b.classList.add("is-done"); setTimeout(function () { b.classList.remove("is-done"); }, 1500); toast("Embed code copied"); }); return;
        case "native":
          if (navigator.share) { navigator.share({ title: text, url: url }).catch(function () { /* dismissed */ }); }
          else copyText(url).then(function () { toast("Link copied"); });
          return;
      }
      if (href) window.open(href, "_blank", "noopener,width=640,height=560");
    });
  });
  function copyLink() { var it = byHandle[state.cur]; if (!it) return; copyText(shareUrl(it)).then(function () { el.copyBtn.classList.add("is-done"); el.copyBtn.textContent = "Copied"; setTimeout(function () { el.copyBtn.classList.remove("is-done"); el.copyBtn.textContent = "Copy link"; }, 1500); toast("Link copied"); }); }
  el.copyBtn.addEventListener("click", copyLink);
  if (el.copyUrl) el.copyUrl.addEventListener("focus", function () { this.select(); });

  /* ---------- view: player | grid ---------- */
  function setView(v) {
    state.view = v;
    el.viewPlayer.hidden = v !== "player"; el.viewGrid.hidden = v !== "grid";
    $$("[data-view-btn]").forEach(function (b) { var on = b.getAttribute("data-view-btn") === v; b.classList.toggle("is-on", on); b.setAttribute("aria-pressed", on ? "true" : "false"); });
    if (v === "grid") { if (state.kind === "yt" && state.yt) { try { state.yt.pauseVideo(); } catch (e) { /* ignore */ } } if (state.kind === "tt") ttSend("pause"); stopCountdown(); }
    else if (state.cur && el.player.classList.contains("is-mounted")) { if (state.kind === "yt" && state.yt) { try { state.yt.playVideo(); } catch (e) { /* ignore */ } } if (state.kind === "tt") ttSend("play"); }
  }
  $$("[data-view-btn]").forEach(function (b) { b.addEventListener("click", function () { setView(b.getAttribute("data-view-btn")); }); });
  $$("[data-views]").forEach(function (v) { v.textContent = "▶ " + fmtN(v.getAttribute("data-views")); });

  /* ---------- cinema ---------- */
  function setCinema(on, persist) {
    root.classList.toggle("is-cinema", on);
    document.documentElement.classList.toggle("lw-cinema-lock", on);
    el.backdrop.hidden = !on;
    el.cinema.setAttribute("aria-pressed", on ? "true" : "false");
    if (persist !== false) LS.set("learn:watch:cinema", on);
    if (on) { setView("player"); closeSheet(); }
  }
  el.cinema.addEventListener("click", function () { setCinema(!root.classList.contains("is-cinema")); });
  el.backdrop.addEventListener("click", function () { setCinema(false); });
  el.stage.addEventListener("click", function (e) { if (root.classList.contains("is-cinema") && (e.target === el.stage || e.target === el.player)) setCinema(false); });

  /* ---------- bottom sheets (mobile): comments + share ---------- */
  var sheetOpen = null;
  function sheetEl(name) { return root.querySelector('[data-sheet="' + name + '"]'); }
  function placeMobile(on) {
    // Move the real panes into the sheets (and back) so there is one DOM for both layouts.
    var cs = sheetEl("comments"), ss = sheetEl("share");
    if (!cs || !ss) return;
    if (on) {
      if (el.commentsPane && el.commentsPane.parentNode !== $("[data-sheet-body]", cs)) $("[data-sheet-body]", cs).appendChild(el.commentsPane);
      if (el.formHost && el.formHost.parentNode !== $("[data-sheet-foot]", cs)) $("[data-sheet-foot]", cs).appendChild(el.formHost);
      if (el.share && el.share.parentNode !== $("[data-sheet-body]", ss)) { $("[data-sheet-body]", ss).appendChild(el.share); $("[data-sheet-body]", ss).appendChild(el.linkrow); }
      el.commentsPane.hidden = false; el.formHost.hidden = false;
    } else {
      closeSheet();
      var scroll = el.panelScroll, panel = $(".lw-panel");
      if (el.share && el.share.parentNode !== scroll) { var tabs = $(".lw-tabs", scroll); scroll.insertBefore(el.share, tabs); scroll.insertBefore(el.linkrow, tabs); }
      if (el.commentsPane && el.commentsPane.parentNode !== scroll) { var vp = $('[data-tab-pane="videos"]', scroll); scroll.insertBefore(el.commentsPane, vp); }
      if (el.formHost && el.formHost.parentNode !== panel) panel.appendChild(el.formHost);
      var cur = $$("[data-tab-btn]").filter(function (b) { return b.getAttribute("aria-selected") === "true"; })[0];
      setTab(cur ? cur.getAttribute("data-tab-btn") : "videos");
    }
  }
  function openSheet(name) {
    var sh = sheetEl(name); if (!sh) return;
    closeSheet();
    sh.hidden = false; el.sheetBackdrop.hidden = false;
    document.documentElement.classList.add("lw-sheet-lock");
    requestAnimationFrame(function () { sh.classList.add("is-open"); });
    sheetOpen = name;
    if (name === "comments") { var ta = $("textarea", sh); if (ta && (sh.getAttribute("data-focus") === "1")) ta.focus(); }
  }
  function closeSheet() {
    if (!sheetOpen) return;
    var sh = sheetEl(sheetOpen); sheetOpen = null;
    document.documentElement.classList.remove("lw-sheet-lock");
    el.sheetBackdrop.hidden = true;
    if (!sh) return;
    sh.classList.remove("is-open"); sh.style.transform = "";
    setTimeout(function () { if (!sh.classList.contains("is-open")) sh.hidden = true; }, 280);
  }
  $$("[data-sheet-close]").forEach(function (b) { b.addEventListener("click", closeSheet); });
  if (el.sheetBackdrop) el.sheetBackdrop.addEventListener("click", closeSheet);
  $$("[data-sheet-handle]").forEach(function (h) {
    var sh = h.closest("[data-sheet]"), y0 = null;
    h.addEventListener("touchstart", function (e) { y0 = e.touches[0].clientY; sh.style.transition = "none"; }, { passive: true });
    h.addEventListener("touchmove", function (e) { if (y0 == null) return; var dy = Math.max(0, e.touches[0].clientY - y0); sh.style.transform = "translateY(" + dy + "px)"; }, { passive: true });
    h.addEventListener("touchend", function (e) { if (y0 == null) return; var dy = (e.changedTouches[0].clientY - y0); sh.style.transition = ""; y0 = null; if (dy > 80) closeSheet(); else sh.style.transform = ""; });
    h.addEventListener("click", closeSheet);
  });
  $$("[data-rail-comments]").forEach(function (b) { b.addEventListener("click", function () { openSheet("comments"); }); });
  $$("[data-rail-share]").forEach(function (b) { b.addEventListener("click", function () { openSheet("share"); }); });
  // swipe up/down on the stage = next/prev (touches on the iframe itself stay with the player)
  (function () {
    var y0 = null, x0 = null;
    el.stage.addEventListener("touchstart", function (e) { y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; }, { passive: true });
    el.stage.addEventListener("touchend", function (e) { if (y0 == null) return; var dy = e.changedTouches[0].clientY - y0, dx = e.changedTouches[0].clientX - x0; y0 = null; if (Math.abs(dy) > 60 && Math.abs(dy) > Math.abs(dx) * 1.5) { if (dy < 0) go(1, true); else go(-1, true); } });
  })();
  placeMobile(isMobile());
  if (mqMobile.addEventListener) mqMobile.addEventListener("change", function (e) { placeMobile(e.matches); });
  else if (mqMobile.addListener) mqMobile.addListener(function (e) { placeMobile(e.matches); });

  /* ---------- keyboard ---------- */
  document.addEventListener("keydown", function (e) {
    if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
    var t = e.target, tag = (t && t.tagName || "").toLowerCase();
    if (tag === "input" || tag === "textarea" || tag === "select" || (t && t.isContentEditable)) return;
    switch (e.key) {
      case "n": case "N": go(1, true); e.preventDefault(); break;
      case "p": case "P": go(-1, true); e.preventDefault(); break;
      case "l": case "L": toggleLike(); e.preventDefault(); break;
      case "c": case "C": setCinema(!root.classList.contains("is-cinema")); e.preventDefault(); break;
      case "Escape": if (sheetOpen) { closeSheet(); e.preventDefault(); } else if (root.classList.contains("is-cinema")) { setCinema(false); e.preventDefault(); } else if (state.countdown) stopCountdown(); break;
      case " ": if (el.stage.contains(document.activeElement) || document.activeElement === el.stage) { togglePlay(); e.preventDefault(); } break;
    }
  });

  /* ---------- mobile queue layout toggle (rail ↔ list) ---------- */
  if (el.filters) {
    var lay = document.createElement("button"); lay.type = "button"; lay.className = "lw-chip lw-chip--layout"; lay.textContent = "List"; lay.setAttribute("aria-pressed", "false");
    lay.addEventListener("click", function () { var on = el.queue.classList.toggle("is-list"); lay.setAttribute("aria-pressed", on ? "true" : "false"); lay.textContent = on ? "Rail" : "List"; });
    el.filters.appendChild(lay);
  }

  /* ---------- boot ---------- */
  recompute();
  var wanted = null;
  try { wanted = new URL(location.href).searchParams.get("v"); } catch (e) { /* ignore */ }
  if (wanted && byHandle[wanted] && state.order.indexOf(wanted) === -1) { state.playlist = "all"; state.filter = "all"; recompute(); }
  var first = (wanted && byHandle[wanted]) ? wanted : (state.order[0] || items[0].handle);
  var firstItem = byHandle[first];
  var tab = cfg.tab === "auto" ? ((firstItem.comments || 0) > 0 ? "comments" : "videos") : cfg.tab;
  setTab(tab);
  select(first, { autoplay: cfg.autoplay });
  if (LS.get("learn:watch:cinema", false) && window.innerWidth > 900) setCinema(true, false);
  root.classList.add("is-ready");

  window.LearnWatch = { select: select, next: function () { go(1, true); }, prev: function () { go(-1, true); }, state: state, items: items, simulateEnded: onEnded, setCinema: setCinema, setView: setView, openSheet: openSheet, closeSheet: closeSheet };
})();
